// function clearContentBasedOnDevice() {
//   const element = document.querySelector(".mobile-device");
//   const elementdesk = document.querySelector(".desktop-device");

//   if (!element) return;

//   if (window.innerWidth <= 768) {
//     elementdesk.innerHTML = "";
//   } else {
//     element.innerHTML = "";
//   }
// }
// clearContentBasedOnDevice();
// window.addEventListener("resize", clearContentBasedOnDevice);

// document.addEventListener("DOMContentLoaded", function () {
//   const button = document.getElementById("add-to-cart-btn");

//   if (!button) return;

//   const observer = new IntersectionObserver(
//     ([entry]) => {
//       if (entry.intersectionRatio === 1) {
//         // Button is fully visible
//         button.classList.remove("not-visible");
//       } else {
//         // Button is partially visible or not visible
//         button.classList.add("not-visible");
//       }
//     },
//     {
//       threshold: 1.0, // Only trigger when 100% of target is visible
//     }
//   );

//   observer.observe(button);
// });

// document.addEventListener("DOMContentLoaded", function () {
//   const button = document.getElementById("add-to-cart-btn");
//   const header = document.querySelector("header"); // Adjust this selector to match your header

//   if (!button) return;

//   // Add a small debounce function to prevent rapid class toggling
//   let toggleTimeout;
//   function debounceClassToggle(action) {
//     clearTimeout(toggleTimeout);
//     toggleTimeout = setTimeout(() => {
//       if (action === "add") {
//         button.classList.add("not-visible");
//       } else {
//         button.classList.remove("not-visible");
//       }
//     }, 50); // 50ms debounce
//   }

//   const observer = new IntersectionObserver(
//     ([entry]) => {
//       // Check if button is fully visible (or almost fully visible)
//       if (entry.intersectionRatio > 0.95) {
//         // Additional check: Is the button overlapped by the sticky header?
//         if (isOverlappedByHeader(button, header)) {
//           debounceClassToggle("add"); // Add not-visible class
//         } else {
//           debounceClassToggle("remove"); // Remove not-visible class
//         }
//       } else {
//         debounceClassToggle("add"); // Add not-visible class
//       }
//     },
//     {
//       threshold: [0, 0.5, 0.95, 1.0], // Multiple thresholds for smoother transitions
//       rootMargin: "-10px 0px", // Slight negative margin to handle edge cases
//     }
//   );

//   observer.observe(button);

//   // Function to check if the button is overlapped by the header
//   function isOverlappedByHeader(button, header) {
//     if (!header) return false;

//     const buttonRect = button.getBoundingClientRect();
//     const headerRect = header.getBoundingClientRect();

//     // Check if the header's bottom edge overlaps with the button's top portion
//     return (
//       headerRect.bottom > buttonRect.top &&
//       headerRect.bottom < buttonRect.bottom &&
//       headerRect.left < buttonRect.right &&
//       headerRect.right > buttonRect.left
//     );
//   }
// });
document.addEventListener("DOMContentLoaded", function () {
  const button = document.getElementById("add-to-cart-btn");
  const blockZone = document.querySelector('.block-zone-availability');
  const header = document.querySelector("header"); // Adjust to match your header

  if (!button) return;

  // Check if device is mobile (max-width: 768px)
  function isMobileDevice() {
    return window.innerWidth <= 768;
  }

  // On mobile, always keep the button fixed at the bottom
  function initializeMobileButtonBehavior() {
    if (isMobileDevice()) {
      // Always add the not-visible class on mobile to show button at bottom
      button.classList.add("not-visible");
      if (blockZone) {
        blockZone.classList.add("not-visible");
      }
    } else {
      // On desktop, remove the class to show button in its original position
      button.classList.remove("not-visible");
      if (blockZone) {
        blockZone.classList.remove("not-visible");
      }
    }
  }

  // Initialize on page load
  initializeMobileButtonBehavior();

  // Handle window resize to update behavior when screen size changes
  let resizeTimeout;
  window.addEventListener("resize", function () {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      initializeMobileButtonBehavior();
    }, 250);
  });

  const closeBtn = document.querySelector(".block-zone-close");
  if (closeBtn) {
    closeBtn.addEventListener("click", function() {

      // Example: remove the parent element
      const parent = closeBtn.closest(".block-zone-availability");
      parent.classList.add('close-clicked');

      // 5th Nov 2025 - Add class to iframe to close the popup
      const chatIframe = document.querySelector('iframe.siena-iframe');
      if (chatIframe) {
        chatIframe.classList.add('siena-iframe--popupclose');
      }
      // if (parent) parent.remove();
    });
  }
});




function adjustZendeskPosition() {
  // Get the elements
  const launcher = document.getElementById('launcher');
  const unreadBadge = document.querySelector('iframe[title="Number of unread messages"]');
  const cartBtnWrapper = document.querySelector('.cart_btn_wrapper');
  
  if (!launcher || !cartBtnWrapper) return; // Exit if elements don't exist
  
  // Function to check if we're on mobile (you can adjust the breakpoint)
  const isMobile = window.innerWidth <= 768;
  
  if (isMobile) {
    // Get the height of the cart button wrapper
    const cartHeight = cartBtnWrapper.offsetHeight;
    console.log(cartHeight);
    
    // Set the bottom position of the launcher
    launcher.style.bottom = `${cartHeight + 15}px`; // 15px additional spacing
    
    // Adjust the unread badge position if it exists
    if (unreadBadge) {
      unreadBadge.style.bottom = `${cartHeight + 70}px`;
    }
  } else {
    // Reset positions on desktop
    launcher.style.bottom = '';
    if (unreadBadge) {
      unreadBadge.style.bottom = '';
    }
  }
}

// Setup a MutationObserver to watch for the Zendesk iframes
function setupZendeskObserver() {
  // Target the body to watch for added iframes
  const targetNode = document.body;
  
  // Options for the observer (watch for added nodes)
  const config = { childList: true, subtree: true };
  
  // Create an observer instance
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      // Check if nodes were added
      if (mutation.addedNodes.length) {
        // Check if our launcher exists now
        const launcher = document.getElementById('launcher');
        if (launcher) {
          // Run the adjustment function
          adjustZendeskPosition();
          
          // Continue checking for a short while to ensure unread badge is also handled
          const checkInterval = setInterval(() => {
            adjustZendeskPosition();
          }, 500);
          
          // Stop checking after 5 seconds
          setTimeout(() => {
            clearInterval(checkInterval);
          }, 5000);
          
          // Disconnect the observer once we've found the launcher
          observer.disconnect();
        }
      }
    });
  });
  
  // Start observing
  observer.observe(targetNode, config);
}

document.addEventListener("DOMContentLoaded", function () {
  // Setup the observer to watch for Zendesk elements
  setupZendeskObserver();
  
  // Run the function also on window resize
  window.addEventListener('resize', adjustZendeskPosition);
  
  // Handle the additional payments toggle
  const toggleButton = document.querySelector(".show_additional_payments");
  const buttontext = document.querySelector(".show_additional_payments .additional_payment_text")
  const paymentSection = document.querySelector("#dynamic-checkout-cart");
  const paymentIcon = document.querySelector(".show_additional_payments .payment_icon")
  
  if (toggleButton && paymentSection) {
    paymentSection.classList.remove("is-active"); // Ensure it's initially hidden
    
    toggleButton.addEventListener("click", function () {
      const isVisible = paymentSection.classList.contains("is-active");
      paymentSection.classList.toggle("is-active");
      if(buttontext){
        buttontext.textContent = isVisible
        ? ""
        : "View Less payments";
        if(!isVisible){
          buttontext.classList.add("text__center");
        }
        else{
          buttontext.classList.remove("text__center");
        }
      }
    
      if(paymentIcon){
        paymentIcon.classList.toggle("is-active")
      }
      
      // Re-adjust Zendesk position when toggling payments
      adjustZendeskPosition();
    });
  }

  // Function to detect if device is iOS
function isIOS() {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
}

// Function to check if Apple Pay is available
function isApplePayAvailable() {
  return window.ApplePaySession && ApplePaySession.canMakePayments();
}

// Function to show Apple Pay button
function showApplePayButton() {
  const applePayElement = document.querySelector('.apple_pay_payments');
  if (applePayElement) {
      applePayElement.classList.remove('hide');
      console.log('Apple Pay button shown');
  }
}

// Function to hide Apple Pay button
function hideApplePayButton() {
  const applePayElement = document.querySelector('.apple_pay_payments');
  if (applePayElement) {
      applePayElement.classList.add('hide');
      console.log('Apple Pay button hidden');
  }
}

// Main function to check and toggle Apple Pay visibility
function checkApplePayAndToggle() {
  if (isIOS() && isApplePayAvailable()) {
      showApplePayButton();
      return true;
  } else {
      hideApplePayButton();
      return false;
  }
}
   checkApplePayAndToggle();
});